import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const ShopSection = () => {
  const [products, setProducts] = useState([]);
  const [grid, setGrid] = useState(false);
  const [active, setActive] = useState(false);
  const navigate = useNavigate();

  const categories = [
    {
      name: "Home Printers",
      img: "assets/images/thumbs/home-printer.jpg",
      link: "/home-printers",
    },
    {
      name: "Office Printers",
      img: "assets/images/thumbs/office-printer.jpg",
      link: "/office-printers",
    },
    {
      name: "Inkjet Printers",
      img: "assets/images/thumbs/inkjet-printer.jpg",
      link: "/inkjet-printers",
    },
    {
      name: "Laser Printers",
      img: "assets/images/thumbs/laser-printer.jpg",
      link: "/laser-printers",
    },
  ];

  // Sidebar toggle
  const sidebarController = () => {
    setActive(!active);
  };

  useEffect(() => {
    fetch("/assets/data/products.json")
      .then((res) => res.json())
      .then((data) => {
        const homePrinters = data.filter(
          (item) =>
            item.category === "home-printer" ||
            item.categories?.includes("home-printer")
        );
        setProducts(homePrinters);
      })
      .catch((err) => console.error("Error loading products:", err));
  }, []);

  // ✅ Add to Cart Handler
  const handleAddToCart = (product) => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");

    if (isLoggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login");
      return;
    }

    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];

    const existing = cart.find((item) => item.id === product.id);

    if (existing) {
      existing.quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    sessionStorage.setItem("cart", JSON.stringify(cart));
    toast.success(`${product.name} added to cart!`);
  };

  return (
    <section className="shop py-80">
      <div className="container container-lg mb-60">
        <h2 className="category-title">Shop By Category</h2>

        <div className="category-grid">
          {categories.map((item, index) => (
            <div className="category-card split-card" key={index}>
              <div className="category-img-top">
                <img src={item.img} alt={item.name} />
              </div>

              <div className="category-info">
                <h4 className="category-name text-center">{item.name}</h4>

                <Link to={item.link} className="category-btn">
                  Shop Now <i className="ph ph-arrow-right" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Product Grid Section */}
      <div className="container container-lg">
        <div className="row">
          <div className="col-lg-12">
            <div className="flex-between gap-16 flex-wrap mb-40">
              <span className="text-gray-900">
                Showing 1–{products.length} of {products.length} results
              </span>
            </div>

            <div className={`list-grid-wrapper ${grid && "list-view"}`}>
              <div className="row gy-4">
                {products.map((item) => {
                  const total = Math.floor(Math.random() * 50) + 10;
                  const sold = Math.floor(Math.random() * total);
                  const percent = Math.round((sold / total) * 100);
                  const rating = (Math.random() * 1 + 4).toFixed(1);
                  const reviews = Math.floor(Math.random() * 9000) + 1000;

                  return (
                    <div className="col-xl-2 col-lg-4 col-md-6" key={item.id}>
                      <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                        <Link
                          to={`/product/${item.id}`}
                          className="product-card__thumb flex-center rounded-8 position-relative"
                        >
                          <img
                            src={
                              item.imageUrl ||
                              "/assets/images/thumbs/product-two-img1.png"
                            }
                            alt={item.name}
                            className="w-auto"
                            style={{ width: "200px", borderRadius: "0.5rem" }}
                          />
                        </Link>

                        <div className="product-card__content mt-16">
                          <div className="flex-align gap-6">
                            <span className="text-xs fw-medium text-gray-500">
                              {rating}
                            </span>
                            <span className="text-15 fw-medium text-warning-600 d-flex">
                              <i className="ph-fill ph-star" />
                            </span>
                            <span className="text-xs fw-medium text-gray-500">
                              ({reviews.toLocaleString()} reviews)
                            </span>
                          </div>

                          <h6 className="title text-lg fw-semibold mt-12 mb-8">
                            <Link
                              to={`/product/${item.id}`}
                              className="link text-line-2"
                            >
                              {item.name}
                            </Link>
                          </h6>

                          <div className="flex-align gap-4">
                            <span className="text-tertiary-600 text-md d-flex">
                              <i className="ph-fill ph-storefront" />
                            </span>
                            <span className="text-gray-500 text-xs">
                              By Printing Dealz
                            </span>
                          </div>

                          <div className="mt-8">
                            <div
                              className="progress w-100 bg-color-three rounded-pill h-4"
                              role="progressbar"
                              aria-valuenow={percent}
                              aria-valuemin={0}
                              aria-valuemax={100}
                            >
                              <div
                                className="progress-bar bg-tertiary-600 rounded-pill"
                                style={{ width: `${percent}%` }}
                              />
                            </div>
                            <span className="text-gray-900 text-xs fw-medium mt-8">
                              Sold: {sold}/{total}
                            </span>
                          </div>

                          <div className="product-card__price my-20">
                            {item.oldPrice && (
                              <span className="text-gray-400 text-md fw-semibold text-decoration-line-through me-2">
                                ${item.oldPrice}
                              </span>
                            )}
                            <span className="text-heading text-md fw-semibold">
                              ${item.price}{" "}
                              <span className="text-gray-500 fw-normal">
                                /Qty
                              </span>
                            </span>
                          </div>

                          {/* ✅ Add to Cart Button Functional */}
                          <button
                            onClick={() => {
                              handleAddToCart(item);
                              window.location.reload();
                            }}
                            className="product-card__cart btn bg-gray-50 hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                            style={{ width: "100%" }}
                          >
                            Add To Cart <i className="ph ph-shopping-cart" />
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopSection;
